export const ORIGYN_NFT_DID = ({ IDL }) => {
    const Time = IDL.Int;
    const Owner = IDL.Tuple(Time, IDL.Principal);
    const RawData = IDL.Tuple(Time, IDL.Vec(IDL.Nat8), IDL.Principal);
    const HeaderField = IDL.Tuple(IDL.Text, IDL.Text);
    const HttpRequest = IDL.Record({
        url: IDL.Text,
        method: IDL.Text,
        body: IDL.Vec(IDL.Nat8),
        headers: IDL.Vec(HeaderField),
    });
    const StreamingCallbackToken = IDL.Record({
        key: IDL.Text,
        sha256: IDL.Opt(IDL.Vec(IDL.Nat8)),
        index: IDL.Nat,
        content_encoding: IDL.Text,
    });
    const StreamingCallbackHttpResponse = IDL.Record({
        token: IDL.Opt(StreamingCallbackToken),
        body: IDL.Vec(IDL.Nat8),
    });
    const StreamingStrategy = IDL.Variant({
        Callback: IDL.Record({
            token: StreamingCallbackToken,
            callback: IDL.Func([StreamingCallbackToken], [StreamingCallbackHttpResponse], ['query']),
        }),
    });
    const HttpResponse = IDL.Record({
        body: IDL.Vec(IDL.Nat8),
        headers: IDL.Vec(HeaderField),
        streaming_strategy: IDL.Opt(StreamingStrategy),
        status_code: IDL.Nat16,
    });
    const nft_monocanister = IDL.Service({
        append_raw_data: IDL.Func([IDL.Vec(IDL.Nat8)], [], []),
        change_index_blob: IDL.Func([IDL.Vec(IDL.Nat8)], [], []),
        get_canister_cycles: IDL.Func([], [IDL.Nat], ['query']),
        get_owner: IDL.Func([], [IDL.Opt(Owner)], ['query']),
        get_ownership_history: IDL.Func([], [IDL.Vec(Owner)], ['query']),
        get_raw_data: IDL.Func([], [IDL.Opt(RawData)], ['query']),
        get_raw_data_history: IDL.Func([], [IDL.Vec(RawData)], ['query']),
        http_request: IDL.Func([HttpRequest], [HttpResponse], ['query']),
        set_controllers: IDL.Func([IDL.Vec(IDL.Principal)], [], []),
        transfer: IDL.Func([IDL.Principal], [], []),
    });
    return nft_monocanister;
};
//# sourceMappingURL=did.js.map